import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89f438f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns contains-menu" }
const _hoisted_2 = {
  key: 0,
  class: "column is-narrow has-overflow-auto"
}
const _hoisted_3 = { class: "tabs is-centered mb-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "Enabled", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "Archived", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "menu" }
const _hoisted_10 = { class: "menu-list" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "loader is-size-4 mx-auto" })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-add-square" }, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" New configuration ")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "column" }
const _hoisted_19 = { class: "level" }
const _hoisted_20 = { class: "level-left transcription-box" }
const _hoisted_21 = { class: "buttons level-right" }
const _hoisted_22 = ["disabled", "title"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 2,
  class: "notification is-danger"
}
const _hoisted_26 = {
  key: 3,
  class: "notification is-info"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Select a ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "worker configuration", -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" on the left panel to see its details. ")
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = ["disabled", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditableName = _resolveComponent("EditableName")!
  const _component_CreateForm = _resolveComponent("CreateForm")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: _ctx.modalTitle,
    "is-large": !_ctx.readOnly,
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = (value) => _ctx.$emit('update:modelValue', value))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.loading }]),
        disabled: !_ctx.canSave || undefined,
        title: _ctx.saveButtonTitle,
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveConfiguration && _ctx.saveConfiguration(...args)))
      }, " Select ", 10, _hoisted_31)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.readOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (!_ctx.readOnly)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                      _createElementVNode("li", {
                        class: _normalizeClass({ 'is-active': !_ctx.archivedFilter }),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.archivedFilter = false))
                      }, _hoisted_6, 2),
                      _createElementVNode("li", {
                        class: _normalizeClass({ 'is-active': _ctx.archivedFilter }),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.archivedFilter = true))
                      }, _hoisted_8, 2)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("aside", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["no-config", { 'is-active': !_ctx.selectedConfigurationId && !_ctx.configCreate }]),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setConfiguration(null)))
                    }, " No configuration ", 2)
                  ]),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_11, _hoisted_13))
                    : (!_ctx.configurationsError && _ctx.workerId)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.workerConfigurations[_ctx.workerId], (configuration) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: configuration.id
                          }, [
                            _createElementVNode("a", {
                              class: _normalizeClass({ 'is-active': _ctx.selectedConfigurationId === configuration.id && !_ctx.configCreate }),
                              onClick: ($event: any) => (_ctx.setConfiguration(configuration.id))
                            }, _toDisplayString(_ctx.truncateShort(configuration.name)), 11, _hoisted_14)
                          ]))
                        }), 128))
                      : _createCommentVNode("", true),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createNewConfiguration && _ctx.createNewConfiguration(...args))),
                      class: _normalizeClass({ 'is-active': _ctx.configCreate })
                    }, _hoisted_17, 2)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.selectedConfigurationId && _ctx.selectedConfiguration && !_ctx.configCreate)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, [
                    _createVNode(_component_EditableName, {
                      instance: _ctx.selectedConfiguration,
                      "save-function": _ctx.renameConfiguration,
                      class: "subtitle",
                      enabled: !_ctx.readOnly && !_ctx.selectedConfiguration.archived
                    }, null, 8, ["instance", "save-function", "enabled"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["button is-light mb-0", { 'is-loading': _ctx.loading, 'is-info': _ctx.archiveButtonState, 'is-danger': !_ctx.archiveButtonState }]),
                      disabled: !_ctx.canToggleArchive || undefined,
                      title: _ctx.archiveButtonTitle,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleArchive && _ctx.toggleArchive(...args)))
                    }, _toDisplayString(_ctx.archiveButtonState ? 'Enable' : 'Archive'), 11, _hoisted_22),
                    _createElementVNode("button", {
                      disabled: _ctx.readOnly,
                      class: "button is-primary is-light mb-0",
                      title: "Clone this configuration",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cloneConfiguration && _ctx.cloneConfiguration(...args)))
                    }, " Clone ", 8, _hoisted_23)
                  ])
                ]),
                _createElementVNode("pre", null, _toDisplayString(_ctx.prettify(_ctx.selectedConfiguration.configuration)), 1)
              ], 64))
            : (_ctx.configCreate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_CreateForm, {
                    onSetConfiguration: _ctx.setConfiguration,
                    onToggleArchived: _cache[6] || (_cache[6] = ($event: any) => (_ctx.archivedFilter = $event)),
                    onConfigCreated: _cache[7] || (_cache[7] = ($event: any) => (_ctx.configCreate = false, _ctx.archivedFilter = false)),
                    "worker-id": _ctx.workerId,
                    "worker-version-id": _ctx.workerVersionId,
                    "new-configuration": _ctx.newConfiguration
                  }, null, 8, ["onSetConfiguration", "worker-id", "worker-version-id", "new-configuration"])
                ]))
              : (_ctx.configurationsError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.configurationsError), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_30))
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-large", "model-value"]))
}